import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tCentro/theme/design";
import * as React from "react";
import { css } from "styled-components";

export interface DownloadIconStyles {
    downloadIcon?: InjectableCss;
}

export const downloadIconStyles: DownloadIconStyles = {
    downloadIcon: {
        css: css`
            display: flex;
            justify-content: center;
            width: 24px;
            svg {
                height: 18px !important;
                width: 18px !important;
            }
            & path {
                fill: ${COLORS.black};
            }
        `,
    },
};

const styles = downloadIconStyles;

const DownloadIcon: React.FC = () => {
    return (
        <StyledWrapper {...styles.downloadIcon}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.75 6.75H2.25C1.00723 6.75 0 7.75898 0 9V12.375C0 12.9962 0.503789 13.5 1.125 13.5H2.25V16.875C2.25 17.4962 2.75379 18 3.375 18H14.625C15.2462 18 15.75 17.4962 15.75 16.875V13.5H16.875C17.4962 13.5 18 12.9962 18 12.375V9C18 7.75898 16.991 6.75 15.75 6.75ZM13.5 15.75H4.5V12.375H13.5V15.75ZM15.1875 10.4062C14.7217 10.4062 14.3438 10.0283 14.3438 9.5625C14.3438 9.09598 14.7217 8.71875 15.1875 8.71875C15.6533 8.71875 16.0312 9.09598 16.0312 9.5625C16.0312 10.0301 15.6551 10.4062 15.1875 10.4062ZM4.5 2.25H12.5684L13.5 3.18199V5.625H15.75V2.71582C15.75 2.41755 15.6313 2.13152 15.4204 1.92059L13.8296 0.329766C13.6195 0.118652 13.3312 0 13.0359 0H3.375C2.75414 0 2.25 0.503789 2.25 1.125V5.625H4.5V2.25Z" fill="#262525"/>
            </svg>
        </StyledWrapper>
    );
};

export default React.memo(DownloadIcon);
